import { AppComponent } from './app/app.component';

AppComponent.bootstrap();
